<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">火热报名中| 第五届Light创造营邀你一起破茧成光！</div>
      <div class="news-date">2025年3月6日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <div style="background-color: #e9f2f96d; padding: 20px;">
          <p>当三月的海风漫过鼓浪屿琴键</p>
          <p>日光岩下的木棉染红了沙坡尾的黄昏</p>
          <p>在三角梅攀上红砖骑楼的季节</p>
          <p>又是一年<span class="mark-text highlight">Light创造营</span></p>
          <p>如春芽破土</p>
          <p>
            <span class="mark-text highlight">5年</span>
              时间里，我们走过
            <span class="mark-text highlight">7座</span>
            城市，汇聚
            <span class="mark-text highlight">20000+</span>
            公益创造者，一起探寻未成年人保护、素质教育、助老友好、环境保护、社区公益等多种议题的科技创新可能。在
            <span class="mark-text highlight">新一轮</span>
            的探索中，如果你也有想实现的
            <span class="mark-text highlight">公益理想</span>
            ，请了解我们，加入我们，一起让
            <span class="mark-text highlight">技术公益</span>
            灵感在鹭岛的潮声中
            <span class="mark-text highlight">破茧成光</span>
            吧！
          </p>
        </div>
        <div class="news-content-mark">
          <div style="font-size: 18px; margin-top: 30px;">● 什么是Light创造营？</div>
        </div>
        <p>
          2025 Light创造营由
          <span class="mark-text">腾讯公益慈善基金会、厦门大学教育发展基金会</span>
          主办，
          <span class="mark-text">腾讯SSV、厦门大学人工智能研究院、腾讯优图实验室、腾讯云智能</span>
          联合承办，
          <span class="mark-text">腾讯科技</span>
          特别支持，旨在连接更多元的力量，将AI技术应用到更多解决社会问题、创造社会价值的场景中。
        </p>
        <p>
          本届
          <span class="mark-text highlight">Light创造营</span>
          面向高校学生群体，围绕AI+社会公益议题（不限方向），征集技术公益解决方案。我们希望通过发掘更多未来可期的学生群体力量，收获不同视角的公益创意思考；我们希望能与更多的同行者一起努力，让技术更好服务于人，
          <span class="mark-text highlight">让公益的光芒，照亮更多的角落。</span>
        </p>
        <div class="news-content-mark">
          <div style="font-size: 18px; margin-top: 30px;">● 申报要求</div>
        </div>
        <p>
          <span class="mark-text">申报主体要求</span>
          本活动申报者应具备以下全部资格：
        </p>
        <p>（1）有完全民事行为能力的自然人；</p>
        <p>（2）本次活动面向中国大陆境内高校学生团队（1-5人）；</p>
        <p>（3）同一作品仅可提交一次，允许跨学校自由组队，每人只能参加一支队伍；</p>
        <p>
          <span class="mark-text"># 高校学生团队说明 #</span>
        </p>
        <p style="font-size: 12px;">*主办方有权决定、调整申报的类型，各申报主体的标准释译请以官方机构说明为准。</p>
        <p>- 需为中国大陆境内注册的高等院校的学生，可来自大学、专门学院、高等专科学校等；</p>
        <p>- 申报团队需保证申报的团队成员皆在就读年限内，已毕业学生无法申报；</p>
        <p>- 申报团队的成员构成可由同一院校组成或多校同学组成，但请留意最终的荣誉将归属于队长所属的高校，请同学们自行商议确认；</p>
        <p>- 团队形式参与（团队规模：最少1人，最多5人）；</p>
        <p>
          <span class="mark-text">申报项目类别</span>
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news77.webp"/>
          </div>
        </div>
        <p>
          本届活动主题
          <span class="mark-text">全面开放，不设固定议题方向，</span>
          参与者无需提交已实际落地项目，只要拥有富有创意的技术公益想法，即可
          <span class="mark-text">免费报名参与。</span>
          鼓励团队跨领域探索，
          <span class="mark-text">将前沿技术与公益理念深度融合，</span>
          共同推动技术在社会共益领域的创新应用，开创共享共益的新未来。
        </p>
        <p>
          <span class="mark-text">申报作品要求</span>
        </p>
        <p>
          <span class="mark-text">初选作品说明：</span>
          每组参选作品
          <span class="mark-text">提交文字说明（200字左右），</span>
          请完整清晰的说明项目的构思，其中务必写出活动主旨的技术公益部分。
        </p>
        <p>
          <span class="mark-text">复选作品说明：</span>
          每组参选团队务必使用组委会统一模版PPT，
          <span class="mark-text">准备方案内容</span>
          （包括但不限团队名称、项目介绍、实现思路、亮点展示等），并录制项目方案演示视频，请在最终截止时间内发送给工作人员。
        </p>
        <p>
          <span class="mark-text">路演作品说明：</span>
          每组参选团队务必使用组委会统一模版PPT，准备方案内容（包括但不限团队名称、项目介绍、实现思路、亮点展示等），并在最终截止时间内发送给工作人员。（参选团队需到场进行项目方案陈述，未到场则视为放弃路演资格）。
        </p>
        <p>
          <span class="mark-text">申报时间安排</span>
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news77/news77_1.webp"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div style="font-size: 18px; margin-top: 30px;">● 我们将提供</div>
        </div>
        <p>
          <span class="mark-text highlight">项目资助</span>
        </p>
        <p>创意项目（90名）：公益资助（现金）<strong>5000元</strong>；</p>
        <p>优秀项目（11名）：公益资助（现金）<strong>50000元</strong>；</p>
        <p style="font-size: 12px;">
          *以上公益资助应用于项目后续的执行落地，包括但不限于公益应用的完善、推广、普及、合作等。<br>
          *以上实体现金均为税前额度，将以获得资助的项目团队为单位进行颁发，由获得资助的项目团队内部自行分配。
        </p>
        <p>
          <span class="mark-text highlight">探访实践</span>
        </p>
        <div>
          <div style="display: flex; flex-wrap: wrap; justify-content: center;">
            <img class="news-image" style="width: 40%; margin-right: 10px;" src="../img/detail/activity/news77/news77_2.webp"/>
            <img class="news-image" style="width: 40%" src="../img/detail/activity/news77/news77_3.webp"/>
            <img class="news-image" style="width: 40%; margin-right: 10px; margin-top: 10px;" src="../img/detail/activity/news77/news77_4.webp"/>
            <img class="news-image" style="width: 40%; margin-top: 10px;" src="../img/detail/activity/news77/news77_5.webp"/>
          </div>
          <div style="text-align: center; font-size: 12px; color: #858585; margin-top: 10px;">过往实践</div>
        </div>
        <p>
          有机会与专家共同
          <span class="mark-text highlight">实地参访公益项目</span>
          ，深入一线公益机构，考察一线项目实践，
          <span class="mark-text highlight">接触一线受助人群，体悟真实社会问题。</span>
        </p>
        <p>
          <span class="mark-text highlight">结识Light多元伙伴</span>
        </p>
        <div>
          <div style="display: flex; flex-wrap: wrap; justify-content: center;">
            <img class="news-image" style="width: 40%; margin-right: 10px;" src="../img/detail/activity/news77/news77_6.webp"/>
            <img class="news-image" style="width: 40%" src="../img/detail/activity/news77/news77_7.webp"/>
            <img class="news-image" style="width: 40%; margin-right: 10px; margin-top: 10px;" src="../img/detail/activity/news77/news77_8.webp"/>
            <img class="news-image" style="width: 40%; margin-top: 10px;" src="../img/detail/activity/news77/news77_9.webp"/>
          </div>
          <div style="text-align: center; font-size: 12px; color: #858585; margin-top: 10px;">伙伴</div>
        </div>
        <p>
          <span class="mark-text highlight">
            <a style="text-decoration: none;" href="https://mp.weixin.qq.com/s?__biz=Mzk0OTYxNDgwNg==&mid=2247490145&idx=1&sn=3f026efa313464d0d98813c8ec37081d&scene=21#wechat_redirect">腾讯SSV还将不定期推出针对公益议题申报的直播讲解，希望为你打开更多技术公益的新思路。</a>
          </span>
          <span style="font-size: 12px; color: #888888;">（点击文字跳转了解更多）</span>
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news77/news77_10.webp"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div style="font-size: 18px; margin-top: 30px;">● 网申指南</div>
        </div>
        <p>请扫描下方二维码，进入腾讯问卷内填写申请所需信息，按照问卷指引，完成全部申请流程。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news77/news77_11.webp"/>
          </div>
        </div>
        <p>
          若您已完成上述所有步骤，则您已完成Light创造营报名流程；若未完成，请务必在截止日期（
          <span class="mark-text highlight">招募截止日期2025年4月20日</span>
          ）前完成相应步骤。
        </p>
        <p>
          如果在过程中遇到问题，请在“腾讯优图实验室”公众号后台回复“
          <span class="mark-text highlight">Light创造营QA</span>
          ”，添加小助手咨询，或者发送邮件到邮箱dewqi@tencent.com（邮件主题请按照：【Light创造营】+申请问题”命名），我们会尽快回复您的邮件。
        </p>

        <div style="background-color: #e9f2f96d; padding: 20px; text-align: center;">
          <p><span class="mark-text highlight">当鹭江的春潮漫向天际线</span></p>
          <p><span class="mark-text highlight">何不执起你心中的光束</span></p>
          <p><span class="mark-text highlight">与这座城市共舞</span></p>
          <p><span class="mark-text highlight">青年创造者们</span></p>
          <p><span class="mark-text highlight">现在就行动起来，加入我们吧！</span></p>
        </div>
        <div class="news-content-mark">
          <div style="font-size: 18px; margin-top: 30px;">● 联合公益传播伙伴</div>
          <span>排名不分先后</span>
        </div>
        <p>腾讯公益慈善基金会、厦门大学教育发展基金会、腾讯Light计划、腾讯科技、腾讯技术公益、腾讯云智能、腾讯优图实验室、腾讯SSV、腾讯CSIG、腾讯云开发者、腾讯技术工程、腾讯高校合作、厦门大学人工智能研究院、新周刊、长三角之声、SegmentFault 思否、智东西、今日人工智能、益优青年、恩派公益、社会价值投资联盟（深圳）、Impact Hub Shenzhen、清华x-lab、西安交通大学教育基金会、广州市越秀区科莱美特环境保护交流中心、Bottledream、ADM、赛氪、郭郭的打怪日记、犀盐数据、腾云悦智、智渔、上海洄澜心理咨询中心、淄博市蓝色蔚来社会创新发展中心、IDC Lab</p>
        <div class="news-content-mark">
          <div style="font-size: 18px; margin-top: 30px;">● 往届回顾</div>
        </div>
        <div style="text-align: center;">
          <p><span class="mark-text highlight"><a href="https://mp.weixin.qq.com/s?__biz=Mzg5MDM1ODU2Ng==&mid=2247483899&idx=2&sn=94bebe08f3db42bd14ee1c8030ce7568&scene=21#wechat_redirect">第一届创造营</a></span></p>
          <p><span class="mark-text highlight"><a href="https://mp.weixin.qq.com/s?__biz=Mzg5MDM1ODU2Ng==&mid=2247484839&idx=1&sn=38252bd40c4a7b6ae9f757ff1a554dad&scene=21#wechat_redirect">第二届创造营</a></span></p>
          <p><span class="mark-text highlight"><a href="https://mp.weixin.qq.com/s?__biz=Mzg5MDM1ODU2Ng==&mid=2247486178&idx=1&sn=74f5ce6bab40dbf7b3d18eb00552bce0&scene=21#wechat_redirect">第三届创造营</a></span></p>
          <p><span class="mark-text highlight"><a href="https://mp.weixin.qq.com/s?__biz=Mzg5MDM1ODU2Ng==&mid=2247486508&idx=1&sn=caddf911bc708ac8ba47280f270ddb5c&scene=21#wechat_redirect">第四届创造营</a></span></p>
        </div>

        <p><span class="mark-text highlight"><a href="https://wj.qq.com/r/login.html?s_url=https%3A%2F%2Fwj.qq.com%2Fs2%2F13519846%2Ffb2e%2F&sid=13519846&hash=fb2e&login_type=unite&scene_type=respondent">·点击直达报名页面·</a></span></p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News67',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
  .right-text {
    font-size: 12px;
    text-align: right;
    color: #0152d9;
  }
  .news-literature {
    max-height: 180px;
    padding: 15px;
    overflow-y: scroll;
    background-color: #ebebeb;
  }
  .short-center{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News77.vue